import {Spinner} from "@blueprintjs/core";
import {Intent} from "@blueprintjs/core/src/common/intent";
import styled from "@emotion/styled";

type LoadingSpinnerProps = {
  loading?: boolean;
  children?: JSX.Element;
  size?: number;
  intent?: Intent;
};

const CenteredSpinner = styled(Spinner)`
  display: flex;
  justify-content: center;
  height: 100%;
`;

export const LoadingSpinner = ({loading, children, size, intent}: LoadingSpinnerProps) => {
  if (loading !== undefined && children && !loading) {
    return children;
  } else {
    return <CenteredSpinner size={size} intent={intent} />;
  }
};
